import { Component, Vue } from 'vue-property-decorator';
import { RegistrationsHeader, RegistrationsFilter, RegistrationsList } from '@/components/registrations';
import RegistrationsStore from '@/store/modules/RegistrationsStoreModule';
import { AppStoreModule, RegistrationsStoreModule } from '@/store';
import { OnboardingRegistrationStatus } from '@/common/viewModels/Enums';
import IAdminService from '@/services/http/interfaces/IAdminService';
import AppStore from '@/store/modules/AppStoreModule';

@Component({
  components: {
    RegistrationsHeader,
    RegistrationsFilter,
    RegistrationsList,
  },
})
export default class Registrations extends Vue {

  registrations$: RegistrationsStore = RegistrationsStoreModule;
  app$: AppStore = AppStoreModule;

  private adminService?: IAdminService;

  get isLoading(): boolean {
    return this.app$.isLoading;
  }

  mounted() {
    this.initServices();
    this.registrations$.getRegistrations(this.adminService!);
  }

  initServices(): void {
    this.adminService = this.$factory.createAdminService();
  }

  filterChange(filter: string): void {
    this.registrations$.setFilter(filter);
  }

  pageChange(page: number): void {
    this.registrations$.setCurrentPage(page);
  }

  statusChange(status: OnboardingRegistrationStatus[]): void {
    this.registrations$.setRegistrationStatusFilter(status);
  }

  registrationClicked(registrationId: string): void {
    this.$router.push({
      name: 'RegistrationsDetails',
      params: {
        registrationId,
      },
    });
  }
}
